module.exports = __webpack_public_path__ + "img/04p-Shop_651.245931ac.jpg";